import {validateHexColor} from './regularExpressions';

type matchRule = [RegExp, string];

export const hexColorRule: matchRule = [validateHexColor, 'Must be a valid hex color, e.g. #6658EA or #665'];
